'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var button = require('./button-c50f4784.js');

var ButtonsContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  margin-top: 21px;\n  padding-top: 16px;\n  border-top: 1px solid ", ";\n  display: flex;\n"], ["\n  margin-top: 21px;\n  padding-top: 16px;\n  border-top: 1px solid ", ";\n  display: flex;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var StyledButton = styled__default(button.Button)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  height: 30px;\n\n  ", "\n"], ["\n  height: 30px;\n\n  ",
    "\n"])), function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return (variant === constants.BUTTON_VARIANT.PRIMARY
        ? "&:hover {\n    background-color: " + theme.colors.primary + ";\n  }\n\n  &:active,\n  &:focus {\n    outline-color: " + theme.colors.primary + ";\n  } "
        : null);
});
var templateObject_1, templateObject_2;

exports.ButtonsContainer = ButtonsContainer;
exports.StyledButton = StyledButton;
